export class UnidadesFiltrosLimites {
    nome: string;
    cor: string;
    id: string;
    orgao_id :string;
    poligonos : [{
      paths: [
          {
              lat: string,
              lng: string
          }
      ]
    }
    ];
    lat: string;
    lng: string;
    checked: boolean;
    icon?: string;
}


// WEBPACK FOOTER //
// ./src/app/models/UnidadesFiltroLimites.ts